import React from 'react';
import CampaignSection from '../components/CampaignSection';

const CampaignsPage: React.FC = () => {
  return <CampaignSection />;
};

export default CampaignsPage; 